
import projectDraw from './project-draw'
import { getToken  } from '@/utils/auth'
import projectChooseor from './project-draw-choose'
import { getNewProjectList, createNewProject, updateProject } from '@/api/enterprise'
import dayjs from 'dayjs'
const wellknown = require("wellknown");
export default {
  props: ['building', 'originCheckVal'],
  watch: {
  },
  components: {
    projectDraw,
    projectChooseor
  },
  data() {    
    return {
      wkt: null,
      range: 0,
      validateForm: {
        project_id: '',
        project_name: '',
        group_id: ''
      },
      fileList: [],
      layerId: null,
      groupOptions: [],
      layerLoading: false,
      showIndoor: true,
      saveLoading: false,
      
    }
  },
  mounted() {  
      
  },
  methods: { 
    setProjectDefaultName() {
      if (!this.validateForm.project_name) {
          this.validateForm.project_name = `项目-${dayjs().format('MM-DD HH:mm:ss')}`
      }      
      this.saveLocal()
    },
    saveRange() {
        this.saveLoading = true
        if (!this.wkt) {
          this.saveLoading = false
          return this.$toasted.error('请上传文件',{position: "top-center", duration: 2000})          
        }
        this.saveProject(this.wkt, {}, null)
    },
    upProjectRange() {
      if (this.range == 3) {
        return false
      }    
      this.changeRange()  
      this.range = 3  
      this.getGroups()    
    },  
    moveAnddictSelectPolygon(polygons) {
        // console.log(JSON.stringify(polygons))
        // debugger
        // 合并所有多边形的点                 
        let allPoints = polygons.flat(2);
         
        // 计算边界框
        
        let bounds = allPoints.reduce((bounds, coord) => bounds.extend(coord), new mapboxgl.LngLatBounds(allPoints[0], allPoints[0]));

        // 计算边界框的宽度和高度
        let width = bounds.getEast() - bounds.getWest();
        let height = bounds.getNorth() - bounds.getSouth();

        // 根据边界框的宽度和高度确定 maxZoom 的值
        let maxZoom;
        if (width > 0.1 || height > 0.1) {
          maxZoom = 14;
        } else if (width > 0.01 || height > 0.01) {
          maxZoom = 16;
        } else {
          maxZoom = 18;
        }        
        // 移动并缩放地图
        this.building.fitBounds(bounds, {
          padding: {top: 10, bottom: 25, left: 15, right: 5},
          maxZoom: maxZoom  
        });
    },
    clearFile() {
      
      this.$refs.fileUpload.clearFiles()
      this.fileList = []
      if (this.building.getLayer('polygon_view_wkt')) {
          this.building.removeLayer('polygon_view_wkt')
          this.building.removeLayer('polygon_view_wkt-layer')
          
          this.building.removeSource('polygon_view_wkt')
      }
    },
    uploadError(e,d) {      
      this.$toasted.error(JSON.parse(e.message)['msg'],{position: "top-center", duration: 2000})
      
    },
    uploadFileSuccess(res, fileList) {                              
      this.wkt = res.data.wkt
      this.fileList = [fileList]
      const geojson = wellknown.parse(this.wkt); 
           
      if (geojson.type == 'MultiPolygon') {
        this.moveAnddictSelectPolygon(geojson.coordinates)
      } else {
        this.moveAnddictSelectPolygon([geojson.coordinates])
      }                  
      if (this.building.getLayer('polygon_view_wkt')) {
          this.building.removeLayer('polygon_view_wkt')
          this.building.removeLayer('polygon_view_wkt-layer')
          
          this.building.removeSource('polygon_view_wkt')
      }
      this.building.addSource('polygon_view_wkt', {
        'type': 'geojson',
        'data': geojson
      });

      this.building.addLayer({
        'id': 'polygon_view_wkt',
        'type': 'fill',
        'source': 'polygon_view_wkt',
        'layout': {},
        'paint': {
          'fill-color': '#00ff00', // 选择你想要的颜色
          'fill-opacity': 0.5
        }
      });
      this.building.addLayer({
        'id': 'polygon_view_wkt-layer',
        'type': 'line',
        'source': 'polygon_view_wkt',
        'layout': {},
        'paint': {
          'line-color': '#fbb03b', // 选择你想要的颜色
          'line-dasharray': [2, 2] // 设置虚线模式，例如每2个像素的线段和2个像素的间隙
        }
      })
      
    },
    getUploadFileData() {
      return {} // {project_id: this.project_id}
    },
    getHeader() {
      return { token: getToken() }
    },
    putProjectOne(data) {
      if ($('#attr_put_data').length == 0) {                
        this.layerId = this.$layer.iframe({
              content: {
                content: projectChooseor, //传递的组件对象
                parent: this,// 当前的vue对象      
                data:{
                  // building: this.building,              
                }//props
              },
              maxmin: true,
              shade: false,
              time: 0,
              skin: 'custom-layer-class-add',
              shadeClose: false,
              resize: false,
              scrollbar: false,
              offset: [ '300px'],
              area:['650px','330px'],
              title:"选择绘制",
              cancel: function() {
              }
          });
          $('.vl-notify-main').addClass('custom-layer-class-add')
          setTimeout( () => {            
              $('#attr_put_data').data('attr_data', JSON.stringify(data)) 
              $('#attr_put_data').click()
          }, 1000)
          
      } else {
          $('#attr_put_data').data('attr_data', JSON.stringify(data)) 
          $('#attr_put_data').click()
      }
      
    },
    getRangeTitle() {
      if (this.range == 1) {
        return '地图上绘制范围'
      } else if (this.range == 2) {
        return '图层中选择范围'
      } else if (this.range == 3) {
        return '上传项目范围'
      }
    },
    async getGroups() {
      const res = await getNewProjectList({})      
      this.groupOptions = res.data      
      this.validateForm.group_id = res.data[0].group_id
    }, 
    drawRange() {   
        if (this.range == 1) {
          return false
        }
        this.changeRange()
        this.getGroups()     
        this.range = 1
        this.showDraw()        
    },
    showDraw() {
        this.layerId = this.$layer.iframe({
          content: {
            content: projectDraw, //传递的组件对象
            parent: this,//当前的vue对象      
            data:{
              // building: this.building,              
            }//props
          },
          maxmin: true,
          shade: false,
          time: 0,
          skin: 'custom-layer-class-add',
          shadeClose: false,
          resize: false,
          scrollbar: false,
          offset: [ '300px'],
          area:['650px','330px'],
          title:"项目绘制",
          cancel: function() {
          }
        });        
       $('.vl-notify-main').addClass('custom-layer-class-add')
    },
    saveLocal() {
         this.$refs['validateForm'].validate((valid) => {          
            if (valid) {
              $('#saveLog').click()
            }
         })
        
    },

    async drawMapRange() {
      if (this.range == 2) {
          return false
      }
      this.changeRange()
      this.getGroups()
      let layers = window.widget.plotManager.draw.map.getStyle().layers;                      
      let keyNames = this.originCheckVal.map( item => item.keyName)        
      let keies = layers.find( data => {
          return keyNames.findIndex( item => item == data.id) > -1
      })      
      if (!keies) {
          return this.$toasted.show('请先选择图层', {position: "top-center", duration: 500})          
      }
      this.range = 2
      this.$emit('addProjectsLayerToMap', true)            
    },
    changeRange() {
      this.$emit('addProjectsLayerToMap', false)
      this.$layer.closeAll()
      if (this.building.getLayer('polygon_view_wkt')) {
          this.building.removeLayer('polygon_view_wkt')
          this.building.removeLayer('polygon_view_wkt-layer')
          
          this.building.removeSource('polygon_view_wkt')
      }      
      let draw = window.widget.plotManager.draw.mapboxDraw
      draw.deleteAll()      
      this.validateForm =  {
        project_name: '',
        group_id: '',
        project_id: ''
      }
    },
    // 保存
    async saveProject(wkt, style, attribute) {
        this.saveLoading = true        
        try {
          if (this.validateForm.project_id) {
            let saveData = { project_id: this.validateForm.project_id, group_id: this.validateForm.group_id,  project_data: wkt, style}
            if (attribute) {
                saveData.attribute = attribute
            }
            await updateProject(saveData)            
          } else {
            try {
              const res = await createNewProject({ group_id: this.validateForm.group_id, project_name: this.validateForm.project_name, project_data: wkt, style})
              if (res.code == 0) {
                this.validateForm.project_id = res.data.project_id
                if ( process.client ) {
                  let newProjectNum = window.localStorage.getItem('newProjectNum') || 0
                  newProjectNum++
                  window.localStorage.setItem('newProjectNum', newProjectNum)
                }
                                              
                this.$toasted.success('操作成功',{position: "top-center", duration: 500})
              }
              
            } catch (error) {              
            }                        
          }
          this.saveLoading = false          
          return {project_id: this.validateForm.project_id, project_name: this.validateForm.project_name}
        } catch (error) {
          this.saveLoading = false
        }
    },
    cancelAll() {
        this.range = 0
        this.$layer.closeAll()  
        this.$emit('addProjectsLayerToMap', false)
        this.validateForm =  {
          project_name: '',
          group_id: '',
          project_id: ''
        } 
        if (this.building.getLayer('polygon_view_wkt')) {
            this.building.removeLayer('polygon_view_wkt')
            this.building.removeLayer('polygon_view_wkt-layer')
            
            this.building.removeSource('polygon_view_wkt')
        }   
        let draw = window.widget.plotManager.draw.mapboxDraw
        draw.deleteAll()
        this.fileList = []
        this.wkt = null
    },
    beforeAvatarUpload(file) {        
        // const isJPG = file.type === 'image/jpeg';
        // (.dxf)
        const isLt2M = file.size < 200 * 1024;

        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        if (!isLt2M) {
          return this.$toasted.error('文件不能超过200k！',{position: "top-center", duration: 2000})
         // this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
    },
    goBack() {
      this.range = 0
      this.$layer.closeAll() 
      this.$emit('addProjectsLayerToMap', false)
      this.validateForm =  {
          project_name: '',
          group_id: '',
          project_id: ''
        }  
       if (this.building.getLayer('polygon_view_wkt')) {
            this.building.removeLayer('polygon_view_wkt')
            this.building.removeLayer('polygon_view_wkt-layer')
            
            this.building.removeSource('polygon_view_wkt')
        }    
      let draw = window.widget.plotManager.draw.mapboxDraw
      draw.deleteAll()
      
      this.$emit('backNext')
    },
    showPop() {        
      this.showIndoor = true      
    },
    hidePop() {
      $('#mapboxglXiangmu').removeClass('active')
      this.$emit('hidePop')  
      let draw = window.widget.plotManager.draw.mapboxDraw
      draw.deleteAll()
      this.$layer.closeAll()    
    }

  },
};
